import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';

export const BusinessNameWithLogo = ({
  businessName,
  showLogo,
  logo,
  logoHeight,
  classes,
}) => (
  <div className={classnames(classes.businuessAndLogoContainer, 'logo-and-text-container')}>
    {showLogo && logo && (
      <div className={classnames(classes.placementLogoContainer, 'logo-container')}>
        <CroppedImageView
          resizeImageHeight={logoHeight || 16}
          src={logo.Src}
          originalWidth={logo.Width}
          originalHeight={logo.Height}
          SourceX={logo.CropSettings.SourceX}
          SourceY={logo.CropSettings.SourceY}
          SourceWidth={logo.CropSettings.SourceWidth}
          SourceHeight={logo.CropSettings.SourceHeight}
          aspectRatio={1}
        />
      </div>
    )}
    {businessName && <div className={classnames(classes.placementBusinessNameContainer, 'logo-business-name')}>{businessName}</div>}
  </div>
);

BusinessNameWithLogo.propTypes = {
  businessName: PropTypes.string,
  showLogo: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    businuessAndLogoContainer: PropTypes.string,
    placementLogoContainer: PropTypes.string,
    placementBusinessNameContainer: PropTypes.string,
  }).isRequired,
  logoHeight: PropTypes.number,
  logo: PropTypes.shape({
    Src: PropTypes.string,
    Width: PropTypes.number,
    Height: PropTypes.number,
    CropSettings: PropTypes.shape({
      SourceX: PropTypes.number,
      SourceY: PropTypes.number,
      SourceWidth: PropTypes.number,
      SourceHeight: PropTypes.number,
    }),
  }),
};

BusinessNameWithLogo.defaultProps = {
  businessName: undefined,
  logoHeight: 16,
  logo: undefined,
};
